import type {
    PipelineConfigTemplateListItem,
    PropertyPipelineConfigListItem,
} from './usePipelineConfigApi'
import type { OrgLeadsPipelineConfigListItem } from '../../../EzFolioConfigurations/useOrgPipelineConfigApi'

export function formatPipelineConfigProvenance(
    config: Pick<
        PropertyPipelineConfigListItem,
        | 'created_from_template_key'
        | 'created_from_template_version'
        | 'created_from_season_id'
        | 'created_from_season_name'
        | 'copied_from_name'
        | 'created_from_org_pipeline_id'
        | 'created_from_org_pipeline_name'
    >,
    templatesByKey?: Map<string, PipelineConfigTemplateListItem>,
): string | null {
    if (config.created_from_season_id && config.created_from_season_name) {
        return `Copied from ${config.created_from_season_name}`
    }

    if (config.copied_from_name) {
        return `Copy of ${config.copied_from_name}`
    }

    if (config.created_from_org_pipeline_name) {
        return `Copied from org template · ${config.created_from_org_pipeline_name}`
    }

    const key = config.created_from_template_key
    const version = config.created_from_template_version
    if (!key || version == null) {
        return 'Owned by this property'
    }

    const templateName = templatesByKey?.get(key)?.name ?? key
    return `Copied from EZOS · ${templateName} v${version}`
}

export function formatPipelineConfigMenuLabel(
    config: PropertyPipelineConfigListItem,
    templatesByKey?: Map<string, PipelineConfigTemplateListItem>,
): string {
    const provenance = formatPipelineConfigProvenance(config, templatesByKey)
    return provenance ? `${config.name} — ${provenance}` : config.name
}

export function formatOrgPipelineProvenance(
    config: OrgLeadsPipelineConfigListItem,
    templatesByKey?: Map<string, PipelineConfigTemplateListItem>,
): string | null {
    const key = config.created_from_template_key
    const version = config.created_from_template_version
    if (!key || version == null) {
        return null
    }

    const templateName = templatesByKey?.get(key)?.name ?? key
    return `From ${templateName} v${version}`
}

export function formatOrgPipelineMenuLabel(
    config: OrgLeadsPipelineConfigListItem,
    templatesByKey?: Map<string, PipelineConfigTemplateListItem>,
): string {
    const provenance = formatOrgPipelineProvenance(config, templatesByKey)
    return provenance ? `${config.name} — ${provenance}` : config.name
}
